import React from 'react';
import PageDelegate from './page-delegate';
import { MDCAnchorMenu, MDCButtonIcon, MDCMenu, MDCIconTextInput, MDCTextArea, MDCFabButton, MDCBottomBar, MDCSnackBar, MDCDialog } from '../components/mdc-components';
import { UtilityComponent } from '../components/base'; //base component class for a bottom toolbar

export class BottomToolbarComponent extends React.Component {
  constructor(props) {
    super(props);
    this.getActiveState = this.getActiveState.bind(this);
    this.onClick = this.onClick.bind(this);
    this.state = {
      activeIndex: -1
    };
  }

  getActiveState(index) {
    return this.state.activeIndex === index;
  }

  onClick(event) {
    var target = event.currentTarget;
    var index = parseInt(target.dataset.index);
    var id = target.dataset.id;
    this.setState({
      activeIndex: index
    });
    this.props.onButtonCommand(id);
  }

  onMenuButtonClick(event) {
    var target = event.currentTarget;
    var index = parseInt(target.dataset.index);
    this.setState({
      activeIndex: index
    });
  }

  onMenuSelected(event) {
    var item = event.detail.item;
    var id = item.dataset.id;
    this.props.onMenuCommand(id);
  }

} //base class for a bottom toolbar/fab controller component

export class BottomToolbarController extends React.Component {
  constructor(props) {
    super(props);
    var toolbar = {
      active: this.props.showToolbar
    };
    this.state = {
      toolbar: toolbar
    };
  }

  onFabClick(event) {
    this.fabButton.hide();
    this.state.toolbar.active = true;
    document.cookie = "showToolbar=true;path=/";
    this.setState(this.state.toolbar);
  }

  onButtonCommand(id) {
    if (id === 'exit') this.exitToolbar();
    if (this.props.onCommand) this.props.onCommand(id);
  }

  onMenuCommand(id) {
    if (this.props.onCommand) this.props.onCommand(id);
  }

  exitToolbar() {
    this.state.toolbar.active = false;
    document.cookie = "showToolbar=false;path=/";
    this.setState(this.state.toolbar);
    this.fabButton.show();
  }

} ///actions menu

export class ActionsMenu extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.hide) return null;
    return /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      menuId: "actionsMenu",
      onMenuSelected: this.props.onMenuSelected
    }, /*#__PURE__*/React.createElement(MDCButtonIcon, {
      icon: "more_vert",
      label: "Actions",
      active: this.props.active,
      index: "2",
      anchor: "true"
    }), this.props.showFullMenu ? /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: "actionsMenu",
      cls: "small"
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "create",
      "data-id": "create"
    }, "Create Item"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "view",
      "data-id": "view"
    }, "View Items"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "delete",
      "data-id": "delete"
    }, "Delete Item")) : /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: "actionsMenu",
      cls: "small"
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "create",
      "data-id": "create"
    }, "Create Item"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "view",
      "data-id": "view"
    }, "View Items")));
  }

} ////page actions menu

export class PagesMenu extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var itemStyle = {
      display: 'none'
    };
    if (this.props.showSettings) itemStyle = {};
    return /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      menuId: "pagesMenu",
      onMenuSelected: this.props.onMenuSelected
    }, /*#__PURE__*/React.createElement(MDCButtonIcon, {
      icon: "pages",
      label: "Pages",
      active: this.props.active,
      index: "1",
      anchor: "true"
    }), this.props.showFullMenu ? /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: "pagesMenu",
      cls: "small"
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "page-create",
      "data-id": "page-create"
    }, "Create Page"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "pages-view",
      "data-id": "pages-view"
    }, "View Pages"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "page-settings",
      "data-id": "page-settings"
    }, "Page Settings"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "page-delete",
      "data-id": "page-delete"
    }, "Delete Page"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "dashboard",
      "data-id": "dashboard"
    }, "View Dashboard")) : /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: "pagesMenu",
      cls: "small"
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "page-create",
      "data-id": "page-create"
    }, "Create Page"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "pages-view",
      "data-id": "pages-view"
    }, "View Pages"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "page-settings",
      "data-id": "page-settings",
      style: itemStyle
    }, "Page Settings"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "dashboard",
      "data-id": "dashboard"
    }, "View Dashboard")));
  }

} ///create page dialog content card

export class PageCreate extends React.Component {
  constructor(props) {
    super(props);
    var component = {
      active: false,
      page: null,
      permalink: null,
      tags: [],
      templates: []
    };
    this.state = {
      component: component
    };
  }

  componentDidMount() {}

  onPermalinkChange(event) {}

  onTitleChange(event) {
    var value = event.currentTarget.value;
    this.state.component.page.title = value;
    this.updateState();
  }

  onKeywordsChange(event) {
    var value = event.currentTarget.value;
    this.state.component.page.keywords = value;
    this.updateState();
  }

  onDescriptionChange(event) {
    var value = event.currentTarget.value;
    this.state.component.page.metaDescription = value;
    this.updateState();
  }

  onTagSelected(event) {
    var value = event.detail.item.dataset.value;
    this.state.component.page.tag = value;
    this.updateState();
  }

  onTemplateSelected(event) {
    var value = event.detail.item.dataset.value;
    this.state.component.page.template = value;
    this.updateState();
  }

  updateState() {
    if (this.state.component.page.tag && this.state.component.page.title) {
      var pageId = this.state.component.page.title.replace(/ /g, '-');
      this.state.component.permalink = '/' + this.state.component.page.tag + '/' + pageId;
    }

    if (this.state.component.page.tag && this.state.component.page.template && this.state.component.page.title) {
      this.props.enableDialogAccept();
    }

    this.setState(this.state.component);
  }

  setComponentState(page, tags, templates) {
    this.state.component.active = true;
    this.state.component.page = page;
    this.state.component.tags = tags;
    this.state.component.templates = templates;
    this.setState(this.state.component);
  }

  getComponentState() {
    return this.state.component.page;
  }

  resetComponentState() {
    this.state.component.page = null;
    this.state.component.active = false;
    this.state.component.permalink = null;
    this.setState(this.state.component);
  }

  render() {
    if (!this.state.component.active) return null;
    var tagNodes = this.state.component.tags.map(tag => {
      return /*#__PURE__*/React.createElement("li", {
        key: tag,
        className: "mdc-list-item",
        role: "menuitem",
        tabIndex: "0",
        "data-value": tag
      }, tag);
    });
    var templateNodes = this.state.component.templates.map(template => {
      return /*#__PURE__*/React.createElement("li", {
        key: template.id,
        className: "mdc-list-item",
        role: "menuitem",
        tabIndex: "0",
        "data-value": template.id
      }, template.name);
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "page-dialog-section"
    }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "build"), " Select a tag, template and provide a title to create a new content page. You may also submit meta data for your page."), /*#__PURE__*/React.createElement(MDCIconTextInput, {
      icon: "link",
      value: this.state.component.permalink,
      label: "Permalink",
      disabled: true,
      onChange: this.onPermalinkChange.bind(this)
    }), /*#__PURE__*/React.createElement(MDCIconTextInput, {
      icon: "create",
      label: "Title",
      value: this.state.component.page.title,
      onChange: this.onTitleChange.bind(this)
    }), /*#__PURE__*/React.createElement("p", null), /*#__PURE__*/React.createElement("div", {
      className: "flex-box align-center"
    }, /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      menuId: "tagsMenu",
      onMenuSelected: this.onTagSelected.bind(this)
    }, /*#__PURE__*/React.createElement("button", {
      className: "cms-button icon ink",
      "data-anchor": "true"
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "bookmark"), " Select Tag"), /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: "tagsMenu",
      cls: "small"
    }, tagNodes)), /*#__PURE__*/React.createElement("span", null, "\xA0\xA0\xA0\xA0\xA0\xA0"), /*#__PURE__*/React.createElement(MDCAnchorMenu, {
      menuId: "templatesMenu",
      onMenuSelected: this.onTemplateSelected.bind(this)
    }, /*#__PURE__*/React.createElement("button", {
      className: "cms-button icon ink",
      "data-anchor": "true"
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "border_all"), " Select Template"), /*#__PURE__*/React.createElement(MDCMenu, {
      disableInit: "true",
      id: "templatesMenu",
      cls: "small"
    }, templateNodes))), /*#__PURE__*/React.createElement("p", null, "\xA0"), /*#__PURE__*/React.createElement("div", null, " ", /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "text_fields"), " Meta Data"), /*#__PURE__*/React.createElement(MDCTextArea, {
      value: this.state.component.page.keywords,
      label: "Keywords",
      onChange: this.onKeywordsChange.bind(this)
    }), /*#__PURE__*/React.createElement(MDCTextArea, {
      value: this.state.component.page.metaDescription,
      label: "Description",
      onChange: this.onDescriptionChange.bind(this)
    }));
  }

} ///page settings dialog content card

export class PageSettings extends React.Component {
  constructor(props) {
    super(props);
    var component = {
      active: false,
      page: null
    };
    this.state = {
      component: component
    };
  }

  componentDidMount() {}

  onTitleChange(event) {
    var value = event.currentTarget.value;
    this.state.component.page.title = value;
    this.setState(this.state.component);
  }

  onKeywordsChange(event) {
    var value = event.currentTarget.value;
    this.state.component.page.keywords = value;
    this.setState(this.state.component);
  }

  onDescriptionChange(event) {
    var value = event.currentTarget.value;
    this.state.component.page.metaDescription = value;
    this.setState(this.state.component);
  }

  setComponentState(page) {
    this.state.component.active = true;
    this.state.component.page = page;
    this.setState(this.state.component);
  }

  getComponentState() {
    return this.state.component.page;
  }

  resetComponentState() {
    this.state.component.page = null;
    this.state.component.active = false;
    this.setState(this.state.component);
  }

  render() {
    if (!this.state.component.active) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "page-dialog-section"
    }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
      className: "light-class"
    }, "Permalink:"), " ", /*#__PURE__*/React.createElement("span", null, this.state.component.page.permalink)), /*#__PURE__*/React.createElement("div", {
      className: "flex-page-settings"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Last Updated: "), /*#__PURE__*/React.createElement("span", null, this.state.component.page.dateSummary)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Last edited by: "), /*#__PURE__*/React.createElement("span", {
      className: "highlight-class"
    }, this.state.component.page.editedBy))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Tag: "), /*#__PURE__*/React.createElement("span", {
      className: "highlight-class"
    }, this.state.component.page.tag)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Template: "), /*#__PURE__*/React.createElement("span", {
      className: "highlight-class"
    }, this.state.component.page.template)))), /*#__PURE__*/React.createElement(MDCIconTextInput, {
      icon: "create",
      label: "Title",
      value: this.state.component.page.title,
      onChange: this.onTitleChange.bind(this)
    }), /*#__PURE__*/React.createElement("p", null, "\xA0"), /*#__PURE__*/React.createElement("div", null, " ", /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "text_fields"), " Meta Data"), /*#__PURE__*/React.createElement(MDCTextArea, {
      value: this.state.component.page.keywords,
      label: "Keywords",
      onChange: this.onKeywordsChange.bind(this)
    }), /*#__PURE__*/React.createElement(MDCTextArea, {
      value: this.state.component.page.metaDescription,
      label: "Description",
      onChange: this.onDescriptionChange.bind(this)
    }));
  }

} //edit icon with an attached actions menu

export class EditIconMenu extends React.Component {
  constructor(props) {
    super(props);
  }

  onMenuSelected(event) {
    var item = event.detail.item;
    var id = item.dataset.id;

    if (id === 'edit') {
      if (this.props.onEdit) this.props.onEdit(this.props.entity);
    } else if (id === 'delete') {
      if (this.props.onDelete) this.props.onDelete(this.props.entity);
    }
  }

  render() {
    var id = 'id-' + this.props.entity.id;
    var cls = 'content-edit-icon';
    if (this.props.cls) cls += ' ' + this.props.cls;

    if (this.props.active) {
      return /*#__PURE__*/React.createElement(MDCAnchorMenu, {
        menuId: id,
        onMenuSelected: this.onMenuSelected.bind(this),
        cls: "absolute"
      }, /*#__PURE__*/React.createElement("div", {
        className: cls,
        "data-anchor": "true"
      }, /*#__PURE__*/React.createElement("i", {
        className: "material-icons"
      }, "create")), /*#__PURE__*/React.createElement(MDCMenu, {
        disableInit: "true",
        id: id,
        cls: "small"
      }, /*#__PURE__*/React.createElement("li", {
        className: "mdc-list-item",
        role: "menuitem",
        tabIndex: "0",
        "data-value": "create",
        "data-id": "edit"
      }, "Edit"), /*#__PURE__*/React.createElement("li", {
        className: "mdc-list-item",
        role: "menuitem",
        tabIndex: "0",
        "data-value": "delete",
        "data-id": "delete"
      }, "Delete")));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: "hide"
      });
    }
  }

} ///more actions menu

export class IconActionsMenu extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var id = 'id-' + this.props.item.id;

    if (this.props.active) {
      return /*#__PURE__*/React.createElement(MDCAnchorMenu, {
        menuId: id,
        onMenuSelected: this.props.onMenuSelected
      }, /*#__PURE__*/React.createElement("div", {
        className: this.props.cls,
        "data-anchor": "true"
      }, /*#__PURE__*/React.createElement("i", {
        className: "material-icons"
      }, "more_horiz")), /*#__PURE__*/React.createElement(MDCMenu, {
        disableInit: "true",
        id: id,
        cls: "small"
      }, this.props.children));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: "hide"
      });
    }
  }

} //page toolbar component

export class PageToolbar extends BottomToolbarComponent {
  constructor(props) {
    super(props);
  }

  render() {
    var mode = this.props.mode;
    var hidePublishCss = 'hide';
    var hideToggleCss = 'hide';
    var hideActions = false;
    var showFullActionsMenu = false;
    var showFullPagesMenu = false;
    var showSettings = false;

    switch (mode) {
      case 'CompletePages':
        hideActions = true;
        showFullPagesMenu = true;
        hidePublishCss = '';
        hideToggleCss = '';
        showSettings = true;
        break;

      case 'PartialPages':
        hideActions = true;
        break;

      case 'PartialPagesPublish':
        hideActions = true;
        hidePublishCss = '';
        hideToggleCss = '';
        showSettings = true;
        break;

      case 'PartialPagesPublishWithActions':
        hidePublishCss = '';
        hideToggleCss = '';
        showSettings = true;
        break;

      case 'CompleteActions':
        showFullActionsMenu = true;
        hidePublishCss = '';
        hideToggleCss = '';
        break;

      case 'CompleteActionsNoToggle':
        showFullActionsMenu = true;
        hidePublishCss = '';
        break;

      case 'PartialActions':
        //nothing
        break;

      case 'PartialActionsToggle':
        hideToggleCss = '';
        break;
    }

    return /*#__PURE__*/React.createElement(MDCBottomBar, {
      active: this.props.active
    }, /*#__PURE__*/React.createElement(MDCButtonIcon, {
      cls: hideToggleCss,
      icon: "visibility_off",
      label: "Toggle",
      active: this.getActiveState(0),
      onButtonClick: this.onClick.bind(this),
      index: "0",
      id: "toggle"
    }), /*#__PURE__*/React.createElement(PagesMenu, {
      active: this.getActiveState(1),
      showFullMenu: showFullPagesMenu,
      showSettings: showSettings,
      onMenuSelected: this.onMenuSelected.bind(this)
    }), /*#__PURE__*/React.createElement(ActionsMenu, {
      active: this.getActiveState(2),
      hide: hideActions,
      showFullMenu: showFullActionsMenu,
      onMenuSelected: this.onMenuSelected.bind(this)
    }), /*#__PURE__*/React.createElement(MDCButtonIcon, {
      cls: hidePublishCss,
      icon: "publish",
      label: "Publish",
      active: this.getActiveState(2),
      onButtonClick: this.onClick.bind(this),
      index: "2",
      id: "publish"
    }), /*#__PURE__*/React.createElement(MDCButtonIcon, {
      icon: "exit_to_app",
      label: "Exit",
      active: this.getActiveState(-2),
      onButtonClick: this.onClick.bind(this),
      index: "3",
      id: "exit"
    }));
  }

} //page toolbar/fab controller component

export class PageToolbarController extends BottomToolbarController {
  constructor(props) {
    super(props);
  }

  onMenuCommand(id) {
    if (this.props.onCommand) this.props.onCommand(id);
  }

  enableCreateDialogAccept() {
    this.createDialog.enableAccept();
  }

  render() {
    if (!this.props.authorized) return null;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PageToolbar, {
      active: this.state.toolbar.active,
      onButtonCommand: this.onButtonCommand.bind(this),
      onMenuCommand: this.onMenuCommand.bind(this),
      mode: this.props.mode
    }), /*#__PURE__*/React.createElement(MDCFabButton, {
      icon: "edit",
      onClick: this.onFabClick.bind(this),
      ref: ref => this.fabButton = ref,
      hide: this.props.showToolbar
    }), /*#__PURE__*/React.createElement(MDCSnackBar, {
      ref: ref => this.snackbar = ref
    }), /*#__PURE__*/React.createElement(MDCDialog, {
      ref: ref => this.createDialog = ref,
      onDialogAccept: this.props.onCreateDialogAccept,
      onDialogCancel: this.props.onCreateDialogCancel,
      accept: "Create",
      cls: "large-dialog",
      header: "Create Page"
    }, /*#__PURE__*/React.createElement(PageCreate, {
      ref: ref => this.pageCreate = ref,
      enableDialogAccept: this.enableCreateDialogAccept.bind(this)
    })), /*#__PURE__*/React.createElement(MDCDialog, {
      ref: ref => this.settingsDialog = ref,
      onDialogAccept: this.props.onSettingsDialogAccept,
      onDialogCancel: this.props.onSettingsDialogCancel,
      accept: "Save",
      cls: "large-dialog",
      header: "Page Settings"
    }, /*#__PURE__*/React.createElement(PageSettings, {
      ref: ref => this.pageSettings = ref
    })), this.props.children);
  }

} //base class for page content components

export class PageBaseComponent extends UtilityComponent {
  constructor(props) {
    super(props);
    var data = this.props.initialData;
    var component = {
      active: false,
      content: data
    };
    this.state = {
      component: component
    };
  }

  componentDidMount() {
    PageDelegate.add(this.getContent.bind(this));
    PageDelegate.addToggle(this.toggle.bind(this));
    PageDelegate.addResetToggle(this.resetToggle.bind(this));
  }

  getContent() {
    var data = {
      key: this.props.contentKey,
      content: this.state.component.content
    };
    if (this.onGetContent) data = this.onGetContent(data);
    return data;
  }

  get mediaEntity() {
    return {
      blob: null,
      dataUrl: null,
      size: null,
      total: 0,
      type: "image/jpeg",
      isImage: true,
      title: null,
      meta: null,
      link: null,
      dataLink: null,
      width: 0,
      height: 0,
      imageWidth: null,
      imageHeight: null,
      active: false,
      newTarget: false,
      tagId: null,
      tag: null,
      id: null,
      extension: ".jpg",
      creationTime: "0001-01-01T00:00:00",
      creationTimeUtc: "0001-01-01T00:00:00",
      lastAccesTime: "0001-01-01T00:00:00",
      lastAccessTimeUtc: "0001-01-01T00:00:00",
      lastWriteTime: "0001-01-01T00:00:00",
      lastWriteTimeUtc: "0001-01-01T00:00:00",
      name: null,
      path: null,
      url: null,
      base64String: null,
      stream: null,
      content: null,
      fileAttributes: 0,
      dataStringFormat: "Jpg",
      mimeType: "image/jpeg",
      roles: null
    };
  }

  toggle() {
    if (this.state.component) {
      if (this.state.component.active) this.state.component.active = false;else this.state.component.active = true;
      this.setState(this.state.component);
      this.state.component.active ? this.onToggleOn() : this.onToggleOff();
    }
  }

  resetToggle() {
    this.state.component.active = false;
    this.setState(this.state.component);
    this.onToggleOff();
  }

  onToggleOn() {}

  onToggleOff() {}

} //base class for page toggle components...toggle off/on controlled by bottom toolbar, but does not submit embedded page content

export class PageToggleComponent extends UtilityComponent {
  constructor(props) {
    super(props);
    var data = this.props.initialData;
    var component = {
      active: false,
      content: data
    };
    this.state = {
      component: component
    };
  }

  componentDidMount() {
    PageDelegate.addToggle(this.toggle.bind(this));
    PageDelegate.addResetToggle(this.resetToggle.bind(this));
  }

  toggle() {
    if (this.state.component) {
      if (this.state.component.active) this.state.component.active = false;else this.state.component.active = true;
      this.setState(this.state.component);
    }
  }

  resetToggle() {
    this.state.component.active = false;
    this.setState(this.state.component);
  }

}
export default {
  BottomToolbarComponent,
  BottomToolbarController,
  ActionsMenu,
  PagesMenu,
  PageCreate,
  PageSettings,
  EditIconMenu,
  IconActionsMenu,
  PageToolbar,
  PageToolbarController,
  PageBaseComponent,
  PageToggleComponent
};